import optimized from "../public/optimized-assets.json" with { type: "json" };
let webpSupported = false;
export function assetUrl(url, supported = webpSupported) {
  return supported ? (optimized[url] ?? url) : url;
}
export function assetVariable(url) {
  return "--image-" + url.replace(/[^a-zA-Z0-9]/g, "-");
}
export async function initializeImageFormat(
  createImage = () => new Image(),
  root = document.documentElement,
) {
  // Test lossless WebP with transparency, not just the older lossy-only decoder.
  webpSupported = await new Promise((resolve) => {
    const image = createImage();
    const timer = setTimeout(() => resolve(false), 1500);
    const done = (value) => {
      clearTimeout(timer);
      resolve(value);
    };
    image.onload = () => done(image.width === 1 && image.height === 1);
    image.onerror = () => done(false);
    image.src =
      "data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAAAAEAdQyxpVq4CBiOh/AAA=";
  });
  if (webpSupported)
    for (const [original, alternate] of Object.entries(optimized)) {
      root.style.setProperty(assetVariable(original), `url("${alternate}")`);
    }
  return webpSupported;
}
